module.exports = __webpack_public_path__ + "img/winner.349628ba.png";